export const teamTiers = [
	{ tier: 1, price: 100, linesOfCode: 250000, allowance: "250K LOC" },
	{ tier: 2, price: 500, linesOfCode: 750000, allowance: "750K LOC" },
	{ tier: 3, price: 700, linesOfCode: 1250000, allowance: "1.25M LOC" },
	{ tier: 4, customPlan: true, allowance: "Enterprise" },
];

export const getCheckoutTier = (value) => teamTiers.find((plan) => String(plan.tier) === value && !plan.customPlan);
